var endpointMap = {};
// Add FinSuite bundles to all locale entries
["en","en-US","en-AU","en-CA","en-GB","en-IN","en-SG","en-ZA","hi","hi-IN","ta","ta-IN","te","te-IN","kn","kn-IN","ja","ja-JP","de","de-DE","fr","fr-FR","fr-BE","fr-CA","es","es-ES","es-MX","zh","zh-CN","zh-TW","ko","ko-KR","pt","pt-BR","pt-PT","ar","ar-AE","bn","bn-IN","gu","gu-IN","ml","ml-IN","mr","mr-IN","nl","nl-NL","nl-BE","pl","pl-PL","sv","sv-SE","th","th-TH","tr","tr-TR","vi","vi-VN","it","it-IT","und"].forEach(function(locale) {
	endpointMap[locale] = {
		"pages.common": "common.json",
		"pages.landing": "landing.json",
		"pages.tools": "tools.json"
	};
});

var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
